import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';

import MyAiPageRouteView from './pages/MyAiPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantOverviewIndex from './assistants/overview/Index.vue';
import AssistantSettingsIndex from './assistants/settings/Index.vue';
import AssistantSystemSettingsIndex from './assistants/settings/System.vue';
import AssistantAudienceSettingsIndex from './assistants/settings/Audience.vue';
import AssistantScheduleSettingsIndex from './assistants/settings/Schedule.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import FaqSuggestionsIndex from './responses/FaqSuggestions.vue';
import CustomToolsIndex from './tools/Index.vue';
import KnowledgeIndex from './knowledge/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.MY_AI,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const faqSuggestionsMeta = {
  ...meta,
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

const metaCustomTools = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.MY_AI_CUSTOM_TOOLS,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaV2 = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.MY_AI_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/knowledge'),
    component: KnowledgeIndex,
    name: 'my_ai_assistants_knowledge_index',
    meta: { ...metaV2, permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/overview'),
    component: AssistantOverviewIndex,
    name: 'my_ai_assistants_overview_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'my_ai_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'my_ai_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'my_ai_tools_index',
    meta: metaCustomTools,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'my_ai_assistants_scenarios_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'my_ai_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'my_ai_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/my_ai/:assistantId/faqs/suggestions'
    ),
    component: FaqSuggestionsIndex,
    name: 'my_ai_assistants_faq_suggestions',
    meta: faqSuggestionsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/faqs/pending'),
    redirect: to => ({
      name: 'my_ai_assistants_faq_suggestions',
      params: to.params,
      query: to.query,
    }),
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'my_ai_assistants_settings_index',
    meta,
  },
  // Settings sub-pages
  {
    path: frontendURL('accounts/:accountId/my_ai/:assistantId/settings/system'),
    component: AssistantSystemSettingsIndex,
    name: 'my_ai_assistants_settings_system_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/my_ai/:assistantId/settings/audience'
    ),
    component: AssistantAudienceSettingsIndex,
    name: 'my_ai_assistants_settings_audience_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/my_ai/:assistantId/settings/schedule'
    ),
    component: AssistantScheduleSettingsIndex,
    name: 'my_ai_assistants_settings_schedule_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/my_ai/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'my_ai_assistants_guardrails_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/my_ai/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'my_ai_assistants_guidelines_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'my_ai_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/my_ai/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'my_ai_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/my_ai'),
    component: MyAiPageRouteView,
    redirect: to => {
      return {
        name: 'my_ai_assistants_index',
        params: {
          navigationPath: 'my_ai_assistants_overview_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
